import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer
      className="container-fluid footer-area py-2 mt-auto"
      role="contentinfo"
    >
      <div className="container d-flex justify-content-between align-items-center">
        <p className="mb-0 small text-white">
          &copy; {year} ATXFloods. All rights reserved.
        </p>
        <nav aria-label="Footer Navigation">
          <ul className="list-inline mb-0">
            <li className="list-inline-item">
              <Link to="/about" className="text-decoration-none">
                About
              </Link>
            </li>
            <li className="list-inline-item">|</li>
            <li className="list-inline-item">
              <Link to="/accessibility" className="text-decoration-none">
                Accessibility
              </Link>
            </li>
            <li className="list-inline-item">|</li>
            <li className="list-inline-item">
              <Link to="/privacy" className="text-decoration-none">
                Privacy
              </Link>
            </li>
            <li className="list-inline-item">|</li>
            <li className="list-inline-item">
              <Link to="/terms" className="text-decoration-none">
                Terms
              </Link>
            </li>
            <li className="list-inline-item">|</li>
            <li className="list-inline-item">
              <Link to="/contact" className="text-decoration-none">
                Contact
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    </footer>
  );
};

export default Footer;
